import { render, staticRenderFns } from "./HeadingPage.vue?vue&type=template&id=1fce61da&scoped=true"
import script from "./HeadingPage.vue?vue&type=script&lang=js"
export * from "./HeadingPage.vue?vue&type=script&lang=js"
import style0 from "./HeadingPage.vue?vue&type=style&index=0&id=1fce61da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fce61da",
  null
  
)

export default component.exports